import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoWithNyeHat = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 54",
	xmlns: "http://www.w3.org/2000/svg",
	className: "LogoWithNyeHat_svg__css-1n2sfk3-LogoVector LogoWithNyeHat_svg__eejrmt70",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M6.446 49.328a.567.567 0 0 1 .173.477.63.63 0 0 1-.284.457.589.589 0 0 1-.332.104.623.623 0 0 1-.436-.187L.804 45.403a.602.602 0 0 1 .436-1.032.589.589 0 0 1 .43.18l4.776 4.776Zm4-9.353a.693.693 0 1 0-1.385 0 .693.693 0 0 0 1.386 0Zm18.359-20.074a4.846 4.846 0 0 0-4.846 4.846v11.56l-.346-.353c-.132-.111-10.833-10.986-14.46-14.482a5.42 5.42 0 0 0-3.732-1.564 4.652 4.652 0 0 0-2.997 1.059 4.728 4.728 0 0 0-1.751 3.399 5.046 5.046 0 0 0 1.384 3.78c2.942 3.073 7.518 7.565 11.94 11.906 4.154 4.098 8.453 8.34 11.215 11.207a5.082 5.082 0 0 0 3.655 1.564 4.797 4.797 0 0 0 4.79-4.375c.01-.17.01-.341 0-.512V24.691a4.846 4.846 0 0 0-4.852-4.804v.014Zm-18.58 24.442L1.67 35.767a.623.623 0 0 0-.664-.136.61.61 0 0 0-.335.795.574.574 0 0 0 .134.192l8.556 8.598c.114.114.268.179.43.18a.692.692 0 0 0 .477-.215.602.602 0 0 0 .138-.498.692.692 0 0 0-.18-.34Zm-6.922-2.395a.588.588 0 0 0-.43-.18.595.595 0 0 0-.608.603c0 .16.062.313.173.429l6.624 6.638a.608.608 0 0 0 1.018-.263v-.048a.589.589 0 0 0-.16-.554l-6.617-6.625Zm-1.73 7.082a.498.498 0 0 0-.347-.16.367.367 0 0 0-.284.125.373.373 0 0 0-.062.305 5.13 5.13 0 0 0 3.496 3.772c.109.03.22.05.332.063h.07a.339.339 0 0 0 .318-.201.45.45 0 0 0-.125-.485l-3.399-3.42Zm5.946-10.494a.61.61 0 0 0 1.052-.43.623.623 0 0 0-.173-.429l-6.729-6.714a.588.588 0 0 0-.429-.18.604.604 0 0 0-.57.832.574.574 0 0 0 .134.192l6.715 6.729Zm.249 12.314a.692.692 0 1 0 0 1.384.692.692 0 0 0 0-1.384Zm-6.61-9.545a.692.692 0 1 0 0-1.384.692.692 0 0 0 0 1.384Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#LogoWithNyeHat_svg__a)",
			fillOpacity: .53,
			d: "M37.705 6.816a.8.8 0 0 1 .104-1.368l2.538-1.27a.8.8 0 0 0 .295-.254l1.64-2.317a.8.8 0 0 1 1.368.104l1.271 2.538a.799.799 0 0 0 .253.295l2.317 1.64a.8.8 0 0 1-.104 1.368l-2.538 1.27a.799.799 0 0 0-.295.254l-1.64 2.317a.8.8 0 0 1-1.368-.104l-1.27-2.538a.8.8 0 0 0-.254-.295l-2.317-1.64Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#LogoWithNyeHat_svg__b)",
			d: "m39.806 20.66 2.704-.973 2.195-1.855.974 2.704 1.855 2.195-2.704.974-2.195 1.855-.974-2.704-1.855-2.195Z",
			opacity: .17
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#LogoWithNyeHat_svg__c)",
			d: "M22.946 7.336 21.3 5.945l-2.028-.73 1.391-1.647.73-2.028 1.647 1.39 2.028.731-1.391 1.647-.73 2.028Z",
			opacity: .3
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#LogoWithNyeHat_svg__d)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#LogoWithNyeHat_svg__e)",
					d: "M21.827 20.293 33.353 3.69l4.32 19.748a.986.986 0 0 1-.822 1.191c-5.983.84-9.507.127-14.718-2.92a.987.987 0 0 1-.306-1.415Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#322B5F",
					d: "M21.827 20.293 33.353 3.69l4.32 19.748a.986.986 0 0 1-.822 1.191c-5.983.84-9.507.127-14.718-2.92a.987.987 0 0 1-.306-1.415Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#322B5F",
					fillRule: "evenodd",
					d: "m34.326-1.22 5.3 24.23c.367 1.676-.753 3.354-2.497 3.599-3.122.438-5.74.491-8.317-.022-2.575-.512-4.973-1.564-7.688-3.151-1.522-.89-1.92-2.871-.94-4.283l1.643 1.14a.987.987 0 0 0 .306 1.416c5.21 3.046 8.735 3.759 14.718 2.919a.986.986 0 0 0 .821-1.19l-4.32-19.75-11.525 16.605-1.643-1.14L34.326-1.221Z",
					clipRule: "evenodd"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFD27A",
					d: "M23.265 19.138a.505.505 0 0 0-.643.13l-.795 1.025a.987.987 0 0 0 .306 1.416c5.211 3.046 8.735 3.759 14.718 2.919a.986.986 0 0 0 .822-1.19l-.27-1.233a.505.505 0 0 0-.553-.391c-2.39.282-4.446.302-6.428-.017-2.4-.386-4.626-1.256-7.157-2.66Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#CC7AFF",
					d: "M24.265 16.78a.495.495 0 0 0 .167.717c2.311 1.263 4.262 1.997 6.307 2.326 1.675.269 3.453.273 5.593.037a.495.495 0 0 0 .427-.6L33.353 3.69 24.265 16.78Z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 33.353,
					cy: 3.689,
					r: 2.5,
					fill: "#FFD27A",
					transform: "rotate(11.214 33.353 3.689)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: 25.474,
				x2: 48.551,
				y1: 5.6,
				y2: 7.353,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C66CF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9F8FFF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: 32.562,
				x2: 47.465,
				y1: 18.996,
				y2: 22.989,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C66CF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9F8FFF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: 24.581,
				x2: 21.587,
				y1: 12.665,
				y2: 1.488,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C66CF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9F8FFF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				x1: 33.353,
				x2: 29.202,
				y1: 3.689,
				y2: 24.626,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#CC7AFF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .863,
						stopColor: "#CC7AFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#CC7AFF"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", { children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M20 0h19v28H20z"
			}) })
		] })
	]
});
const ForwardRef = forwardRef(SvgLogoWithNyeHat);
export { ForwardRef as ReactComponent };
